import { useTranslation } from 'react-i18next'

import { Modal, ModalBody, ModalContent, ModalHeader, ModalTitle } from '@/components/ui/Modal'
import type { WidgetOverviewRow } from '@/hooks/api/useWidgets'
import { WhatsAppEmbeddedSignup } from '@/pages/assistants/components/integrations/WhatsAppEmbeddedSignup'

interface WidgetWhatsAppSignupModalProps {
  row: WidgetOverviewRow | null
  onClose: () => void
}

export function WidgetWhatsAppSignupModal({
  row,
  onClose,
}: WidgetWhatsAppSignupModalProps) {
  const { t } = useTranslation()
  const base = 'resources.widgets.whatsapp_signup'

  return (
    <Modal isOpen={!!row} onOpenChange={(isOpen) => !isOpen && onClose()} size="full">
      <ModalContent>
        <ModalHeader onClose={onClose} bordered={false}>
          <ModalTitle>
            {t(`${base}.title`, { assistant: row?.assistant_name ?? '' })}
          </ModalTitle>
        </ModalHeader>
        <ModalBody className="max-h-[calc(100vh-7rem)] overflow-y-auto pt-2">
          {row && <WhatsAppEmbeddedSignup assistantId={row.assistant_id} />}
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
